<template>
  <div v-if="showBanner" id="custom-consent-blackbar">
    <div id="custom-truste-consent-track">
      <div id="custom-truste-consent-content" class="custom-truste-banner">
        <div
          id="custom-truste-consent-text"
          class="custom-truste-messageColumn"
        >
          {{ message }}
        </div>
        <button class="custom-close-btn" @click="closeBanner">X</button>
      </div>
    </div>
  </div>
</template>

<script>
import { detectIncognito } from 'detectincognitojs';

export default {
  name: 'GdprConsentBanner',
  props: {
    message: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showBanner: false,
    };
  },
  mounted() {
    this.checkIncognitoAndLoadCustomGDPR();
  },
  methods: {
    async checkIncognitoAndLoadCustomGDPR() {
      const result = await detectIncognito();
      if (result.isPrivate && result.browserName === 'Safari') {
        console.log('Incognito mode detected in Safari');
        this.showBanner = true;
      } else {
        console.log('Incognito mode not detected or not in Safari');
        this.showBanner = false;
      }
    },
    closeBanner() {
      this.showBanner = false;
    },
  },
};
</script>

<style scoped>
#custom-consent-blackbar {
  border-top: 2px solid #123dba;
}

.custom-truste-banner {
  margin: 0 auto;
  background-color: rgb(224, 242, 255);
  opacity: 1;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.custom-truste-messageColumn {
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: #555;
  margin: 20px 0px;
  width: 80%;
  line-height: 18px;
}

.custom-close-btn {
  font-size: 20px;
  color: #555;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px 0px;
  position: absolute;
  top: 10px;
  right: 10px;
}

.custom-close-btn:hover {
  color: grey;
}

@media screen and (max-width: 1199px) {
  .custom-truste-messageColumn {
    float: none;
    margin: 20px;
    width: auto !important;
  }
}
</style>
